export const EventName = {
  AffiliateAction: 'AffiliateAction',
  /** Coupon code copied from a coupon modal. Deliberately NOT an
   *  AffiliateAction: it's purchase intent, not an outbound click, and folding
   *  it in would inflate the affiliate click count and the listicle funnel. */
  CouponCopy: 'CouponCopy',
  NavTopbarButton: 'NavTopbarButton',
  PageView: '$pageview',
  ServerPageView: 'server-page-view',
  SessionStart: 'session-start',
  WebVital: 'web-vital',
  GscShow: 'gsc-show',
  GscClick: 'gsc-click',
  GscClose: 'gsc-close',
  CspViolation: 'csp-violation',
} as const

export type EventName = (typeof EventName)[keyof typeof EventName]

export const EventType = {
  Impression: 'impression',
  Click: 'click',
  AbTest: 'abtest',
  Performance: 'performance',
  Security: 'security',
  Error: 'error',
} as const

export type EventType = (typeof EventType)[keyof typeof EventType]

export interface AffiliateActionProps {
  action: 'impression' | 'click'
  elementType: string
  partnerType: string
  release: string
  seller: string
  link: string
  testId: string
  position: string
  cta: string
  text: string
  testName: string
  segment?: number
  htSegment?: string
  listicleOrdering?: string
  listiclePosition?: string
  [flag: string]: string | number | boolean | undefined
}

export interface SessionStartProps {
  requestId: string
  distinctId: string
  segment: string
  pageType: string
  path: string
  ttfb?: number
  lcp?: number
  inp?: number
  cls?: number
}

export interface GenericEventProps {
  eventType: EventType
  path: string
  [key: string]: string | number | boolean | undefined
}

export type TrackedEvent = {
  event: EventName | string
  eventType: EventType
  properties: Record<string, string | number | boolean | undefined>
  timestamp: number
}

export interface PageRollup {
  counts: Record<string, number>
  pageUrl: string
  timestamp: number
}

const validEventNames = new Set<string>(Object.values(EventName))

export const isKnownEvent = (name: string): name is EventName => validEventNames.has(name)

export const AD_EVENT_ATTRS = [
  'event-id',
  'event-advertiser-id',
  'event-advertiser',
  'event-type',
  'event-media',
  'event-image',
  'event-name',
] as const

export const AFFILIATE_EVENT_ATTRS = [
  'event-position',
  'event-origin',
  'event-product',
  'event-url',
  'event-seller',
  'event-listicle-position',
  'affiliate-cta',
  'affiliate-text',
  'affiliate-test-name',
  'affiliate-seller-type',
  'affiliate-segment',
] as const

export const ALL_KNOWN_ATTRS = [...AD_EVENT_ATTRS, ...AFFILIATE_EVENT_ATTRS] as const
